import type { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { useFocusActionState } from 'src/providers/FocusActionProvider'

import { Page } from 'src/components/layouts/Page'
import { UpdateAccountDetails } from 'src/components/organisms/UpdateAccountDetails'

import { withAccountRequired, withAuthRequired } from 'src/utils/auth'

const UpdateAccountPage: NextPage = () => {
  const router = useRouter()
  const { setFocussedHeader } = useFocusActionState()

  useEffect(() => {
    setFocussedHeader(() => {
      router.back()
    })
  }, [setFocussedHeader, router])

  return (
    <Page title='Update Account' showBreadcrumbs>
      <UpdateAccountDetails />
    </Page>
  )
}

export default withAccountRequired(withAuthRequired(UpdateAccountPage))
